import { Component, input, linkedSignal, OnInit, output } from '@angular/core';
import { Icon } from '../icon/icon';
import type { CssColor, FontWeight, IconName } from '@appTypes';
import { CSSValuePipe } from '@pipes/css-value-pipe';

@Component({
  selector: 'app-open-close',
  standalone: true,
  imports: [CSSValuePipe, Icon],
  templateUrl: './open-close.html',
  styleUrl: './open-close.scss',
})
export class OpenClose implements OnInit {
  // Inputs
  $_open = input<boolean>(false, { alias: 'open' });
  $open = linkedSignal<boolean>(this.$_open);
  $text = input<string | null>(null, { alias: 'text' });
  $textFontSize = input<string>(undefined, { alias: 'textFontSize' });
  $textTop = input<string>(undefined, { alias: 'textTop' });
  $textRight = input<string>(undefined, { alias: 'textRight' });
  $textBottom = input<string>(undefined, { alias: 'textBottom' });
  $textLeft = input<string>(undefined, { alias: 'textLeft' });
  $textWeight = input<FontWeight>('bold', { alias: 'textWeight' });
  $textColor = input<CssColor>('--black-white', { alias: 'textColor' });
  $gap = input<string>('--gap-small', { alias: 'gap' });
  $icon = input<IconName | null>(null, { alias: 'icon' });
  $iconColor = input<'original' | CssColor>('--primary-dynamic', { alias: 'iconColor' });
  $textWrap = input<boolean>(false, { alias: 'textWrap' });
  $iconSize = input<string>('', { alias: 'iconSize' });
  $iconScale = input<number>(1, { alias: 'iconScale' });
  $iconRotation = input<number>(0, { alias: 'iconRotation' });
  $iconViewBoxAdjustmentX = input<number>(0, { alias: 'iconViewBoxAdjustmentX' });
  $iconViewBoxAdjustmentY = input<number>(0, { alias: 'iconViewBoxAdjustmentY' });
  $emitAtStart = input<boolean>(false, { alias: 'emitAtStart' });

  // Outputs
  valueChange = output<boolean>();

  ngOnInit(): void {
    if (this.$emitAtStart())
      this.valueChange.emit(this.$open());
  }

  // Maneja el evento de abertura / cierre
  toggleOpen() {
    this.$open.update(value => !value);
    this.valueChange.emit(this.$open());
  }
}
